import { useSuspenseQuery } from "@tanstack/react-query";
import api from "apis";

export const useDocumentClassesByCategoryQuery = (categoryUuid: string) => {
  return useSuspenseQuery({
    queryKey: api.document.getDocumentClassesByCategoryKey(categoryUuid),
    queryFn: () => api.document.getDocumentClassesByCategory(categoryUuid),
    select: (data) => data.data.result,
  });
};
